'use client';

import { IGroupInfo } from '@/api/types/product';
import { useSpmDomAttr, useSpmModuleCode } from '@/reporting/spm';
import FaqPart from './FaqPart';
import RelatedBlockLink from './RelatedBlockLink';

interface GoodsListSeoBlockProps {
  groupInfo: IGroupInfo;
  isWeb: boolean;
  noMoreShow: boolean;
  showBottomRelatedLink: boolean;
  sdProductListPageRelatedGroupClick: (item: any, index: number, position: string) => void;
  sdProductListPageRelatedGroupExp: (item: any, index: number, position: string) => void;
  isBot?: boolean;
}

export default function GoodsListSeoBlock({
  groupInfo,
  isWeb,
  noMoreShow,
  showBottomRelatedLink,
  sdProductListPageRelatedGroupClick,
  sdProductListPageRelatedGroupExp,
  isBot = false,
}: GoodsListSeoBlockProps) {
  const hasFaqContent = !!groupInfo?.h_one || !!groupInfo?.faq_list?.length;
  const shouldShowFaq = !isWeb && (isBot ? hasFaqContent : groupInfo?.h_one && noMoreShow);
  // Data SPM DOM 打标（请求头 data-spm=1 开关）：底部相关导航位模块码（A.B.C）打在模块容器，
  // category_entry_NN 坑位码由 RelatedBlockLink 在作用域内自行解析。仅 PC 编码表有该模块；
  // WAP 与无作用域复用查表不命中，零 DOM 差异。
  const getSpmModuleCode = useSpmModuleCode();
  const relatedBottomDomSpm = useSpmDomAttr(getSpmModuleCode('related_categories_bottom'));

  return (
    <>
      {showBottomRelatedLink && (
        <div
          className={`text-center ${
            isWeb ? 'mt-[56px] pt-40 border-t border-solid border-[#eeeeee]' : ''
          }`}
        >
          {groupInfo?.related_block_link && groupInfo?.related_block_link?.length > 0 && (
            <div
              className={`seo-block-link ${isWeb ? 'mb-40' : 'px-[14px]'}`}
              {...relatedBottomDomSpm}
            >
              <div className={`flex flex-wrap ${isWeb ? 'gap-20' : 'gap-12'}`}>
                {groupInfo?.related_block_link?.map((item: any, index: number) => (
                  <RelatedBlockLink
                    key={item.id}
                    item={item}
                    index={index}
                    trackProductListPageRelatedGroupClick={(
                      _item: any,
                      _index: number,
                      _position: string,
                    ) => {
                      sdProductListPageRelatedGroupClick(_item, _index, _position);
                    }}
                    trackProductListPageRelatedGroupExp={sdProductListPageRelatedGroupExp}
                    isWeb={isWeb}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {shouldShowFaq && (
        <FaqPart
          groupInfo={groupInfo}
          defaultExpandAll={isBot}
          defaultQuestionLevel={isBot ? 4 : undefined}
        />
      )}
    </>
  );
}
